import type { QueryClient } from "@tanstack/react-query";

/**
 * After cohort reveals run (charged via the existing reveal workflow), refresh
 * the org's credit balance and any profile-contacts queries so a re-preview
 * reflects the just-revealed data and shows 0 additional credits required.
 */
export function invalidateAfterReveal(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: ["billing", "credits"] });
  queryClient.invalidateQueries({ queryKey: ["/api/billing/credits"] });
  // Profile contacts — keyed ["profile-contacts", profileId] (see
  // hooks/use-contact-reveal.ts::contactsQueryKey). Prefix-match invalidates
  // every profile so a re-preview reflects the just-revealed contacts.
  queryClient.invalidateQueries({ queryKey: ["profile-contacts"] });
  // Enrollment estimate — so re-previewing the same cohort shows 0 new
  // credits required for the now-revealed profiles (spec §4.4).
  queryClient.invalidateQueries({ queryKey: ["enrollment-estimate"] });
}
